import { PageComponent } from "rasengan";
import Image from "@rasenganjs/image";
import Message from "@/components/molecules/Message";
import {
	ChatsActions,
	ChatsOperations,
	ChatsState,
} from "@/store/signals/chats";
import { useActions, useOperations, useSignal } from "@rasenganjs/signals";
import logo from "@/assets/logo-mini-2.svg";
import {
	GraduationCap,
	Languages,
	MailCheck,
	SquareTerminal,
} from "lucide-react";
import Chat from "@/entities/Chat";
import MessageEntity from "@/entities/Message";

const prompts = [
	{
		id: 1,
		description: "Quiz me on world capitals",
		icon: <GraduationCap size={24} className='text-blue-500' />,
		prompt: "Quiz me on world capitals",
	},
	{
		id: 2,
		description: "Help me writing a motivation letter",
		icon: <MailCheck size={20} className='text-green-500' />,
		prompt: "Help me to writing a motivation letter",
	},
	{
		id: 3,
		description: "Translate a sentence",
		icon: <Languages size={24} className='text-red-500' />,
		prompt:
			"Help me to translate a sentence, ask me a question about what you need",
	},
	{
		id: 4,
		description: "Write a program",
		icon: <SquareTerminal size={24} className='text-yellow-500' />,
		prompt:
			"Help me to write a program in javascript. Ask me a question about the script specification",
	},
];

const Home: PageComponent = () => {
	const { getCurrentChat } = useOperations<ChatsOperations>("chats");
	const { create } = useActions<ChatsActions>("chats");
	const { selectedChatId } = useSignal<ChatsState>("chats");

	const chat = getCurrentChat(selectedChatId);

	// Handlers
	const handleCreateChat = (prompt: string) => {
		const chatId = `chat-${Date.now()}`;
		const messageId = `message-${Date.now()}`;

		const message = new MessageEntity({
			id: messageId,
			role: "user",
			content: prompt,
			createdAt: new Date(Date.now()),
		});

		const chat = new Chat({ id: chatId, messages: [message] });

		create(chat);
	};

	return (
		<section className='w-full h-full flex flex-col mt-8 transition-all duration-300 pb-[100px]'>
			{chat ? (
				chat.messages.map((message) => (
					<Message key={message.id} data={message} />
				))
			) : (
				<div className='w-content h-content flex flex-col items-center justify-center gap-8 font-outfitLight'>
					<div className='w-20 h-20 flex items-center justify-center rounded-full bg-card/70 cursor-pointer'>
						<Image src={logo} alt='RasenganAI' width={40} height={"auto"} />
					</div>

					<div className='w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4'>
						{prompts.map((item) => (
							<article
								key={item.id}
								onClick={() => handleCreateChat(item.prompt)}
								className='p-4 border-[1px] border-card rounded-3xl w-full h-[140px] hover:bg-card hover:cursor-default gap-4 flex flex-col transition-all'
							>
								{item.icon}

								<p>{item.description}</p>
							</article>
						))}
					</div>
				</div>
			)}
		</section>
	);
};

Home.path = "/";
Home.metadata = {
	title: "Chat - RasenganAI",
	description: "Chat with RasenganAI.",
};

export default Home;
